var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtArbitrum({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0764 26.4794C21.125 26.4794 26.8339 20.7705 26.8339 13.722C26.8339 6.67345 21.125 0.964478 14.0764 0.964478C7.02794 0.964478 1.31897 6.67345 1.31897 13.722C1.31897 20.7705 7.02794 26.4794 14.0764 26.4794Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6393 14.6043C15.5542 14.6043 15.0971 14.6362 14.0871 14.6362C13.2791 14.6362 12.7157 14.6149 12.5137 14.6043C9.40936 14.4661 7.10238 13.9239 7.10238 13.286C7.10238 12.6481 9.41999 12.1059 12.5137 11.9571V14.0621C12.7157 14.0727 13.3004 14.1152 14.0977 14.1152C15.0652 14.1152 15.5436 14.0727 15.6286 14.0727V11.9677C18.7223 12.1059 21.0293 12.6481 21.0293 13.286C21.0399 13.9239 18.7329 14.4661 15.6393 14.6043ZM15.6393 11.7445V9.85212H19.9555V6.98169H8.20803V9.86275H12.5243V11.7445C9.016 11.9039 6.37946 12.6056 6.37946 13.4348C6.37946 14.2641 9.016 14.9657 12.5243 15.1252V21.1637H15.6393V15.1146C19.1369 14.9551 21.7735 14.2641 21.7735 13.4242C21.7735 12.5843 19.1476 11.9039 15.6393 11.7445Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6200_38226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.8173,
    y: 7,
    width: 14.88,
    height: 14.88,
    rx: 7.44,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8503 11.8528V17.0274C19.8503 17.36 20.0245 17.661 20.3149 17.83L24.7979 20.4173C25.083 20.581 25.4368 20.581 25.7219 20.4173L30.2048 17.83C30.4899 17.6663 30.6695 17.36 30.6695 17.0274V11.8528C30.6695 11.5201 30.4952 11.2191 30.2048 11.0502L25.7219 8.46285C25.4368 8.29917 25.083 8.29917 24.7979 8.46285L20.3149 11.0502C20.0298 11.2139 19.8556 11.5201 19.8556 11.8528H19.8503Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.234 15.4432L25.5951 17.1963C25.5793 17.2438 25.5793 17.2966 25.5951 17.3494L26.6934 20.3644L27.966 19.6305L26.44 15.4432C26.403 15.3482 26.271 15.3482 26.234 15.4432Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5172 12.4968C27.4802 12.4018 27.3482 12.4018 27.3112 12.4968L26.6723 14.2499C26.6565 14.2974 26.6565 14.3502 26.6723 14.403L28.4729 19.34L29.7454 18.606L27.5172 12.5021V12.4968Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2572 8.65816C25.2889 8.65816 25.3206 8.66872 25.347 8.68456L30.1942 11.4831C30.2523 11.5148 30.284 11.5781 30.284 11.6415V17.2385C30.284 17.3019 30.247 17.3653 30.1942 17.3969L25.347 20.1955C25.3206 20.2113 25.2889 20.2219 25.2572 20.2219C25.2255 20.2219 25.1939 20.2113 25.1675 20.1955L20.3202 17.3969C20.2621 17.3653 20.2305 17.3019 20.2305 17.2385V11.6362C20.2305 11.5728 20.2674 11.5095 20.3202 11.4778L25.1675 8.67928C25.1939 8.66344 25.2255 8.65288 25.2572 8.65288V8.65816ZM25.2572 7.83972C25.083 7.83972 24.914 7.88196 24.7556 7.97173L19.9084 10.7702C19.5968 10.9498 19.4067 11.2771 19.4067 11.6362V17.2332C19.4067 17.5923 19.5968 17.9197 19.9084 18.0992L24.7556 20.8977C24.9087 20.9875 25.083 21.0297 25.2572 21.0297C25.4315 21.0297 25.6004 20.9875 25.7589 20.8977L30.6061 18.0992C30.9176 17.9197 31.1077 17.5923 31.1077 17.2332V11.6362C31.1077 11.2771 30.9176 10.9498 30.6061 10.7702L25.7536 7.97173C25.6004 7.88196 25.4262 7.83972 25.2519 7.83972H25.2572Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 19.3454L22.4957 18.1204L23.3933 18.8649L22.5538 19.6358L22.0469 19.3454Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8453 11.2401H23.6151C23.5253 11.2401 23.4408 11.2982 23.4091 11.3827L20.7743 18.6061L22.0468 19.34L24.951 11.3827C24.9774 11.3088 24.9246 11.2349 24.8506 11.2349L24.8453 11.2401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9997 11.2401H25.7694C25.6796 11.2401 25.5951 11.2982 25.5634 11.3827L22.5537 19.6304L23.8262 20.3644L27.1 11.3827C27.1264 11.3088 27.0736 11.2349 26.9997 11.2349V11.2401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6200_38226"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.8173,
    y: 7,
    width: 14.88,
    height: 14.88,
    rx: 7.44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtArbitrum);
export default __webpack_public_path__ + "static/media/usdt_arbitrum.35f6879a312ded026cfae2fd469e969e.svg";
export { ForwardRef as ReactComponent };